module.exports = __webpack_public_path__ + "static/ssl-bg-b6b7459b16398c03e9102e05056cce73.jpg";